<template>
  <div class="manage">
    <div class="treeList">
      <div class="treeItem"
           :class="dataForm.documentTypeId == typeItem.id? 'actTreeItem':''"
           v-for="(typeItem, typeIndex) in typeList"
           :key="'typeItem'+ typeIndex"
           @click="setActType(typeItem.id)"
      >
        {{typeItem.name}}
      </div>
    </div>
    <div class="content">
      <el-container>
        <el-header>
          <el-form :inline="true" :model="dataForm" label-width="100px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="标题：">
                  <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发文字号：">
                  <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="审批状态：">
                  <el-select v-model="dataForm.approveStatus" placeholder="请选择审批状态">
                    <el-option value="0" label="待审批（未提交）">待审批（未提交）</el-option>
                    <el-option value="1" label="撤回">撤回</el-option>
                    <el-option value="2" label="待审批">待审批</el-option>
                    <el-option value="3" label="已通过">已通过</el-option>
                    <el-option value="4" label="已拒绝">已拒绝</el-option>
                    <el-option value="100" label="无审批">无审批</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="发文日期：">
                  <el-date-picker
                          v-model="dataForm.documentDate"
                          @change="documentDateChange"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="activeName == 'third'">
                <el-form-item label="转发状态：">
                  <el-select v-model="dataForm.sendStatus" placeholder="请选择转发状态">
                    <el-option value="1" label="未转发">未转发</el-option>
                    <el-option value="3" label="已退回">已退回</el-option>
                    <el-option value="4" label="已转发">已转发</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="发布日期：">
                  <el-date-picker
                      v-model="dataForm.publishTime"
                      @change="publishTimeChange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="btnRight">
                <el-form-item class="btnList">
                  <el-button type="primary" @click="query()">查 询</el-button>
                  <el-button type="info" @click="reset()">重 置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row v-if="activeName == 'first'">
            <el-col :span="24">
              <div class="operatePanel">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="goToAddAndModiify(1)"
                >新建</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="activeName == 'fifth'">
            <el-col :span="24">
              <div class="operatePanel">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="goToGeneralAddAndModiify(1)"
                >新建</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="activeName == 'second'">
            <el-col :span="24">
              <div class="operatePanel">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="goToGeneralAddAndModiify(1)"
                >综合办发文</el-button>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main ref="main">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-if="isZongheban != 1" label="我的发文(综合办)" name="first">
              <el-table
                      ref="dataTable"
                      :data="documentList"
                      highlight-current-row
                      size="mini"
                      height="100%"
                      border
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                        prop="title"
                        label="标题"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentTypeName"
                        label="公文分类"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentNum"
                        label="发文字号"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentDate"
                        label="发文日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="createTime"
                        label="发布日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="applyUserName"
                    label="申请人"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="sendStatusDisplayName"
                        label="提交状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="接收人"
                        :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div>综合办</div>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="operateUserName"
                        label="处理人"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="operateTime"
                        label="处理时间"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="sendStatusReceiveListDisplayName"
                        label="转发状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="approveStatusDisplayName"
                        label="审批状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="goToDetails(scope.row)">详情</el-button>
                    <el-button v-if="scope.row.sendStatus == 4 || scope.row.approveStatus == 3" type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                    <el-button v-if="scope.row.sendStatus == '0' || scope.row.sendStatus == 3" type="text" size="small" @click="handleSubmitClick(scope.row)">提交</el-button>
                    <el-button v-if="scope.row.sendStatus == '0' || scope.row.sendStatus == 3" type="text" size="small" @click="goToAddAndModiify(2,scope.row)">修改</el-button>
                    <el-button v-if="scope.row.sendStatus == '0' || scope.row.sendStatus == 3" type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane v-if="isZongheban != 1" label="我的发文(其他)" name="fifth">
              <el-table
                  ref="dataTable"
                  :data="documentList"
                  highlight-current-row
                  size="mini"
                  height="100%"
                  border
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                    prop="title"
                    label="标题"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="documentTypeName"
                    label="公文分类"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="documentNum"
                    label="发文字号"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="documentDate"
                    label="发文日期"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="createTime"
                    label="发布日期"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="operateUserName"
                    label="处理人"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="operateTime"
                    label="处理时间"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="sendStatusReceiveListDisplayName"
                    label="转发状态"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    prop="approveStatusDisplayName"
                    label="审批状态"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.approveStatus == '0'|| scope.row.approveStatus == 1|| scope.row.approveStatus == 4" type="text" size="small" @click="goToGeneralAddAndModiify(4,scope.row)">修改</el-button>
                    <el-button v-if="scope.row.approveStatus == '0'|| scope.row.approveStatus == 1|| scope.row.approveStatus == 4" type="text" size="small" @click="deleteGeneralItem(scope.row)">删除</el-button>
                    <el-button v-if="scope.row.approveStatus == 2" type="text" size="small" @click="handleWithdrawClick(scope.row)">撤回</el-button>
                    <el-button v-if="scope.row.sendStatus == 4 || scope.row.approveStatus == 3 ||
                      scope.row.approveStatus == 2"
                               type="text" size="small" @click="goToGeneralDetails(scope.row)">详情</el-button>
                    <el-button v-if="scope.row.sendStatus == 4 || scope.row.approveStatus == 3" type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane v-if="isZongheban == 1" label="综合办发文" name="second">
              <el-table
                      ref="dataTable"
                      :data="documentList"
                      highlight-current-row
                      size="mini"
                      height="100%"
                      border
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                        prop="title"
                        label="标题"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentTypeName"
                        label="公文分类"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentNum"
                        label="发文字号"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentDate"
                        label="发文日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="createTime"
                        label="发布日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="operateUserName"
                        label="处理人"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="operateTime"
                        label="处理时间"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="sendStatusReceiveListDisplayName"
                        label="转发状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="approveStatusDisplayName"
                        label="审批状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.approveStatus == '0'|| scope.row.approveStatus == 1|| scope.row.approveStatus == 4" type="text" size="small" @click="goToGeneralAddAndModiify(2,scope.row)">修改</el-button>
                    <el-button v-if="scope.row.approveStatus == '0'|| scope.row.approveStatus == 1|| scope.row.approveStatus == 4" type="text" size="small" @click="deleteGeneralItem(scope.row)">删除</el-button>
                    <el-button v-if="scope.row.approveStatus == 2" type="text" size="small" @click="handleWithdrawClick(scope.row)">撤回</el-button>
                    <el-button v-if="scope.row.sendStatus == 4 || scope.row.approveStatus == 3 ||
                      scope.row.approveStatus == 2"
                      type="text" size="small" @click="goToGeneralDetails(scope.row, 2)">详情</el-button>
                    <el-button v-if="scope.row.sendStatus == 4 || scope.row.approveStatus == 3" type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane v-if="isZongheban == 1" label="收文处理" name="third">
              <el-table
                      ref="dataTable"
                      :data="documentList"
                      highlight-current-row
                      size="mini"
                      height="100%"
                      border
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                        prop="title"
                        label="标题"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentTypeName"
                        label="公文分类"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentNum"
                        label="发文字号"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentDate"
                        label="发文日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="createTime"
                        label="发布日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="applyUserName"
                        label="申请人"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="接收人"
                        :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div>综合办</div>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="operateUserName"
                        label="处理人"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="operateTime"
                        label="处理时间"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="sendStatusReceiveListDisplayName"
                        label="转发状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="approveStatusDisplayName"
                        label="审批状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button v-if="(scope.row.approveStatus == '0'|| scope.row.approveStatus == 1)&&scope.row.sendStatus != 3" type="text" size="small" @click="goToProcessingAddAndModiify(1,scope.row)">直接转发</el-button>
                    <el-button v-if="(scope.row.approveStatus == '0'|| scope.row.approveStatus == 1)&&scope.row.sendStatus != 3" type="text" size="small" @click="goToProcessingAddAndModiify(2,scope.row)">提交审批并转发</el-button>
                    <el-button v-if="(scope.row.approveStatus == '0'|| scope.row.approveStatus == 1)&&scope.row.sendStatus != 3" type="text" size="small" @click="goToProcessingFallback(scope.row)">回退</el-button>
                    <el-button v-if="(scope.row.approveStatus == '0'|| scope.row.approveStatus == 1)&&scope.row.sendStatus != 3" type="text" size="small" @click="goToProcessingDetails(scope.row)">详情</el-button>
                    <el-button v-if="scope.row.approveStatus == 2&&scope.row.sendStatus != 3" type="text" size="small" @click="handleWithdrawClick(scope.row)">撤回</el-button>
                    <el-button v-if="scope.row.approveStatus == 2|| scope.row.sendStatus == 4 || scope.row.sendStatus == 3" type="text" size="small" @click="goToProcessingDetails(scope.row)">详情</el-button>
                    <el-button v-if="scope.row.sendStatus == 4" type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="收文查阅" name="fourth">
              <el-table
                      ref="dataTable"
                      :data="documentList"
                      highlight-current-row
                      size="mini"
                      height="100%"
                      border
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                        prop="title"
                        label="标题"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentTypeName"
                        label="公文分类"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentNum"
                        label="发文字号"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentDate"
                        label="发文日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="createTime"
                        label="发布日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="applyUserName"
                        label="申请人"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="operateUserName"
                        label="处理人"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="operateTime"
                        label="处理时间"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="createTime"
                        label="转发状态"
                        :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.sendStatus == 4">已转发</div>
                    <div v-else>未转发</div>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="approveStatusDisplayName"
                        label="审批状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="checkStatusDisplayName"
                        label="查阅状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" v-if="scope.row.checkStatus != 1" @click="goToProcessingDetails(scope.row, 2)">查阅</el-button>
                    <el-button type="text" size="small" v-if="scope.row.checkStatus == 1" @click="goToProcessingDetails(scope.row)">详情</el-button>
                    <el-button type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-main>
        <el-footer>
          <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="dataForm.pageIndex"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="dataForm.pageSize"
                  layout="total, prev, pager, next, sizes, jumper"
                  :total="total"
          ></el-pagination>
        </el-footer>
      </el-container>
    </div>

    <submit-review v-if="submitVisible" ref="submitReview" @refreshDataList="getSendList()"></submit-review>
  </div>
</template>

<script>
import submitReview from "../submit-review";

import {
  getSendListService,
  getChecklistService,
  getTypeListService,
  deleteSendFileService,
  deleteZonghebanFileService,
  setInternalStatusService,
} from '@/services/documentServices'
import {getSalesInvoiceService} from "@/services/invoiceServices";
import addDetail from "@/page/engineering/beforehand/add-detail";
import {recallApproveProcessService} from "@/services/engineering";
export default {
  name: "index",
  data(){
    return {
      activeName: 'first',
      dataForm: {
        queryType: 1,
        title: '',  //标题
        documentNum: '',  //发文字号
        documentTypeId: '',  //分类id
        approveStatus: '',  //审批状态
        documentDate: [],  //发文时间
        documentDateStart:'',  //发文-开始时间
        documentDateEnd:'',    //发文-结束时间
        publishTime: [],  //发布时间
        publishDateStart:'',  //发布-开始时间
        publishDateEnd:'',    //发布-结束时间
        sendStatus:'',    //发送状态过滤
        pageIndex: 1,
        pageSize: 10,
      },
      documentList: [],

      typeList: [], //分类列表

      submitVisible: false,
      isZongheban: sessionStorage.getItem('isZongheban')
    }
  },
  components:{
    submitReview
  },
  created() {
    if(this.isZongheban == 1) {
      this.dataForm.queryType = 2;
      this.activeName = 'second'
    }
  },
  methods:{
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.query();
      this.getTypeList();
    },
    query(){
      this.dataForm.pageIndex = 1;
      if (this.dataForm.queryType != 4){
        this.getSendList();
      }else {
        this.getChecklist();
      }
    },
    // 重置数据
    reset(){
      this.dataForm = {
        queryType: this.dataForm.queryType,
        title: '',  //标题
        documentNum: '',  //发文字号
        documentTypeId: '',  //分类id
        approveStatus: '',  //审批状态
        documentDate: [],  //发文时间
        documentDateStart:'',  //发文-开始时间
        documentDateEnd:'',    //发文-结束时间
        publishTime: [],  //发布时间
        publishDateStart:'',  //发布-开始时间
        publishDateEnd:'',    //发布-结束时间
        sendStatus:'',    //发送状态过滤
        pageIndex: 1,
        pageSize: 10,
      }
      if (this.dataForm.queryType != 4){
        this.getSendList();
      }else {
        this.getChecklist();
      }
    },
    handleClick(tab, event){
      this.dataForm.pageIndex = 1;
      this.dataForm.sendStatus = '';
      if(this.activeName == 'first'){
        this.dataForm.queryType = 1;
        this.getSendList();
      }else if(this.activeName == 'second'){
        this.dataForm.queryType = 2;
        this.getSendList();
      }else if(this.activeName == 'fifth'){
        this.dataForm.queryType = 2;
        this.getSendList();
      }else if(this.activeName == 'third'){
        this.dataForm.queryType = 3;
        this.dataForm.sendStatus = '1';
        this.getSendList();
      }else if(this.activeName == 'fourth'){
        this.dataForm.queryType = 4;
        this.getChecklist();
      }
    },
    //查询分类列表
    getTypeList(){
      let paramsData = {
        pageIndex: 1,
        pageSize: 10000,
      }
      getTypeListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.typeList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 查询列表信息
    getSendList(){
      let paramsData = {
        ...this.dataForm
      }
      getSendListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.documentList = res.data;
          this.total = res.total;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 查询我的查阅列表
    getChecklist(){
      let paramsData = {
        ...this.dataForm
      }
      getChecklistService(paramsData).then( res => {
        if(res.code == 10000000){
          this.documentList = res.data;
          this.total = res.total;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 设置分类
    setActType(id){
      this.dataForm.documentTypeId = id;
      if (this.dataForm.queryType != 4){
        this.getSendList();
      }else {
        this.getChecklist();
      }
    },
    // 选择发布日期
    publishTimeChange(val){
      if(val){
        this.dataForm.publishDateStart = this.dataForm.publishTime[0];
        this.dataForm.publishDateEnd = this.dataForm.publishTime[1];
      }else{
        this.dataForm.publishDateStart = '';
        this.dataForm.publishDateEnd = '';
      }
    },
    documentDateChange(val){
      if(val){
        this.dataForm.documentDateStart = this.dataForm.documentDate[0];
        this.dataForm.documentDateEnd = this.dataForm.documentDate[1];
      }else{
        this.dataForm.documentDateStart = '';
        this.dataForm.documentDateEnd = '';
      }
    },
    // 删除列表
    deleteItem(item){
      if(item.approveStatus != '0' && item.approveStatus != 1 && item.approveStatus != '4'){
        this.$message.error('该公文已开始审批，不允许删除！');
        return
      }
      this.$confirm('此操作将永久删除该公文, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteSendItem(item);
      }).catch(() => {

      });
    },
    deleteSendItem(item){
      let paramsData = {
        systemFileInternalId: item.id,
      }
      deleteSendFileService(paramsData).then( res => {
        if(res.code == 10000000){
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getSendList();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },

    // 删除综合办列表
    deleteGeneralItem(item){
      if(item.approveStatus != '0'  && item.approveStatus != '1' && item.approveStatus != '4'){
        this.$message.error('该公文已开始审批，不允许删除！');
        return
      }
      this.$confirm('此操作将永久删除该公文, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let paramsData = {
          systemFileInternalId: item.id,
        }
        deleteZonghebanFileService(paramsData).then( res => {
          if(res.code == 10000000){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getSendList();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      }).catch(() => {

      });
    },
    // 撤回审批流
    handleWithdrawClick(item){
      this.$confirm("确定要撤回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          itemId : item.id,
          type: 'OFFICIAL_DOCUMENT_INTERNAL'
        }
        recallApproveProcessService(params).then( res => {
          if(res.code == 10000000){
            this.$message.success('撤回成功');
            this.getSendList();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      });
    },
    // 去我的公文详情页面
    goToDetails(item){
      this.bus.$emit("navMenuChange", {
        routeId: "documentManageDetails",
        routeParam: {
          id: item.id,
        }
      });
    },
    // 去新增修改页面
    goToAddAndModiify(documentType,item = null){
      if(documentType == 1){
        this.bus.$emit("navMenuChange", {
          routeId: "documentManageAdd",
          routeParam: {
            id: item!= null? item.id: '',
            documentType: documentType
          }
        });
      }else{
        if(item.approveStatus == '0' || item.approveStatus == '4'|| item.approveStatus == 1){
          this.bus.$emit("navMenuChange", {
            routeId: "documentManageModiify",
            routeParam: {
              id: item!= null? item.id: '',
              documentType: documentType
            }
          });
        }else {
          this.$message.error('该公文仅允许待审核（未提交）和已拒绝状态的数据修改！');
          return
        }
      }
    },
    //提交审批
    handleSubmitClick(item){
      this.$confirm('确定要提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let paramsData = {
          systemFileInternalId: item.id,
          sendStatus: 1,
        }
        setInternalStatusService(paramsData).then( res => {
          if(res.code == 10000000){
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.getSendList();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      }).catch(() => {

      });

    },

    goToOtherAddAndModiify(documentType,item = null){
      if(documentType == 1){
        this.bus.$emit("navMenuChange", {
          routeId: "documentManageAddOther",
          routeParam: {
            id: item!= null? item.id: '',
            documentType: documentType
          }
        });
      }
    },


    // 去综合办新增修改页面
    goToGeneralAddAndModiify(documentType,item = null){
      if(documentType == 1){
        this.bus.$emit("navMenuChange", {
          routeId: "generalOfficeAdd",
          routeParam: {
            id: item!= null? item.id: '',
            documentType: documentType
          }
        });
      }else{
        if(item.approveStatus == '0' || item.approveStatus == '1'|| item.approveStatus == '4'){
          this.bus.$emit("navMenuChange", {
            routeId: "generalOfficeModiify",
            routeParam: {
              id: item!= null? item.id: '',
              documentType: documentType
            }
          });
        }else {
          this.$message.error('该公文仅允许待审核（未提交）、撤回和已拒绝状态的数据修改！');
          return
        }
      }
    },
    // 去综合办详情页面
    goToGeneralDetails(item, type = 1){
      this.bus.$emit("navMenuChange", {
        routeId: "generalOfficeDetails",
        routeParam: {
          id: item.id,
        }
      });
    },
    // 去收文处理
    goToProcessingAddAndModiify(documentType, item){
      if(item.approveStatus == 2){
        this.$message.error('该公文已经提交审批，不能再次操作！');
        return
      }
      this.bus.$emit("navMenuChange", {
        routeId: "processingSendAndApprove",
        routeParam: {
          id: item.id,
          documentType: documentType,
        }
      });
    },
    // 回退
    goToProcessingFallback(item){
      if(item.approveStatus == 2){
        this.$message.error('该公文已经提交审批，不能再次操作！');
        return
      }
      this.$confirm('确定要回退吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let paramsData = {
          systemFileInternalId: item.id,
          sendStatus: 3,
        }
        setInternalStatusService(paramsData).then( res => {
          if(res.code == 10000000){
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.getSendList();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      }).catch(() => {

      });
    },
    // 去收文处理详情
    goToProcessingDetails(item, type = 1){
      this.bus.$emit("navMenuChange", {
        routeId: "processingDetails",
        routeParam: {
          id: item.id,
          type: type,
        }
      });
    },
    // 分页改变事件
    handleCurrentChange(page) {
      this.dataForm.pageIndex = page;
      if (this.dataForm.queryType != 4){
        this.getSendList();
      }else {
        this.getChecklist();
      }
    },
    // 分页显示数量改变事件
    handleSizeChange(rows) {
      this.dataForm.pageIndex = 1;
      this.dataForm.pageSize = rows;
      if (this.dataForm.queryType != 4){
        this.getSendList();
      }else {
        this.getChecklist();
      }
    },
    // 去打印页面
    goToPrint(item = null){
      if(item.sendStatus != 4){
        this.$message.error('该公文未通过转发，不允许打印');
        return
      }
      this.bus.$emit("navMenuChange", {
        routeId: "documentManagePrint",
        routeParam: {
          id: item!= null? item.id: ''
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  /deep/.el-tabs__header{
    padding-right: 0 !important;
    .el-tabs__nav-wrap{
      padding-left: 30px;
    }
  }
  .manage{
    height: 100%;
    display: flex;
    justify-content: space-between;
    .treeList{
      width: 15%;
      background-color: white;
      .treeItem{
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .actTreeItem{
        color: #069dbc;
      }
    }
    .content{
      width: 83%;
      background-color: white;
    }
  }
  .btnRight {
    display: flex;
    justify-content: flex-end;
    .btnList{
      text-align: right;
    }
    /deep/.el-form-item__content{
      height: auto;
    }
  }
</style>
